import { useEffect } from "react";

import BottonSheet from "src/components/ui/BottonSheet";
import EditProduct from "./EditProduct";
import AddService from "./AddService";
import AddOther from "./AddOther";

import useDeviceSize from "src/hooks/useDeviceSize";

const EditSheet = ({
  quoItemDetail,
  docType,
  isOpen,
  onSubmit,
  onClose,
  onRemoveElement,
  isRemoveDisabled,
  dataProductList,
  dataServiceType,
}) => {
  const [deviceWidth] = useDeviceSize();

  useEffect(() => {
    if (deviceWidth > 835) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceWidth]);

  const handleClose = () => {
    onClose();
  };

  const getContentComponent = () => {
    switch (docType) {
      case "product":
        return (
          <EditProduct
            productData={quoItemDetail}
            dataProductList={dataProductList}
            onSubmit={onSubmit}
            onRemoveElement={onRemoveElement}
            onClose={handleClose}
            isRemoveDisabled={isRemoveDisabled}
          />
        );
      case "service":
        return (
          <AddService
            serviceData={quoItemDetail}
            dataServiceType={dataServiceType}
            onRemoveElement={onRemoveElement}
            onSubmit={onSubmit}
            onClose={handleClose}
            isRemoveDisabled={isRemoveDisabled}
          />
        );
      case "other":
        return (
          <AddOther
            otherData={quoItemDetail}
            onRemoveElement={onRemoveElement}
            onSubmit={onSubmit}
            onClose={handleClose}
            isRemoveDisabled={isRemoveDisabled}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <BottonSheet
        title={
          docType === "product"
            ? `แก้ไขรายละเอียดสินค้า`
            : docType === "service"
              ? `แก้ไขรายละเอียดการบริการ`
              : `แก้ไขรายละเอียด`
        }
        onClose={handleClose}
        open={isOpen}
      >
        {getContentComponent()}
      </BottonSheet>
    </>
  );
};

export default EditSheet;
